(function () {
  function buildCartTitle(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return 'Cart Procurement Run';
    }

    if (cart.items.length === 1) {
      return 'Cart · ' + cart.items[0].product_title;
    }

    return 'Cart Procurement Run · ' + cart.items.length + ' items';
  }

  function buildCartItemsSummary(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';

    return cart.items.map(function (item) {
      return [
        item.product_title || '',
        'x' + (item.quantity || 0),
        '-',
        '₱' + (((item.final_line_price || 0) / 100).toLocaleString('en-PH'))
      ].join(' ');
    }).join(' | ');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-quickpay]');
    if (!trigger) return;

    event.preventDefault();

    if (trigger.getAttribute('data-cart-quickpay-enabled') !== 'true') {
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        if ((cart.total_price || 0) < 2000000) return;

        trigger.dataset.productId = 'cart';
        trigger.dataset.productTitle = buildCartTitle(cart);
        trigger.dataset.productHandle = 'cart-procurement';
        trigger.dataset.productVendor = 'BuyCoop';
        trigger.dataset.productPrice = String((cart.total_price || 0) / 100);
        trigger.dataset.productTags = 'cart,procurement';
        trigger.dataset.cooppayDestination = '';
        trigger.dataset.lightningDestination = '';

        trigger.dataset.cartMode = 'true';
        trigger.dataset.cartHasVpi = trigger.getAttribute('data-cart-has-vpi') || 'false';
        trigger.dataset.cartToken = cart.token || '';
        trigger.dataset.cartItemCount = String(cart.item_count || 0);
        trigger.dataset.cartTotal = String((cart.total_price || 0) / 100);
        trigger.dataset.cartItemsSummary = buildCartItemsSummary(cart);

        if (typeof openCoopQRModal === 'function') {
          openCoopQRModal(trigger);
        } else {
          console.error('openCoopQRModal is not available');
        }
      })
      .catch(function (err) {
        console.error('cart-quickpay.js error:', err);
      });
  });
})();